export const isVideoOnlyUser = (userData) => {
  return userData.scopes.includes('video') && !userData.scopes.some((scope) => scope.includes('convo'))
}



// WEBPACK FOOTER //
// ./src/utils/user.js